module.exports = __webpack_public_path__ + "img/xg_slider1.646fd2b5.jpg";